import { Skeleton, Card } from 'antd';
import './HomeDashboardSkeleton.scss';

const HomeDashboardSkeleton = () => {
  return (
    <section className="home-dashboard-container">
      <div className="evaluations-column">
        <Card className="dashboard-skeleton-card">
          <Skeleton active paragraph={{ rows: 4 }} />
        </Card>
      </div>
      <aside className="stats-news-column">
        <div className="stats-container">
          <Card className="dashboard-skeleton-card">
            <Skeleton active paragraph={{ rows: 3 }} />
            <Skeleton.Button active block className="mt-3" />
          </Card>
        </div>
        <div className="news-container">
          <Card className="dashboard-skeleton-card">
            <Skeleton active paragraph={{ rows: 2 }} />
          </Card>
        </div>
      </aside>
    </section>
  );
};

export default HomeDashboardSkeleton;
